import { render, staticRenderFns } from "./debtorIpu.vue?vue&type=template&id=d359e15a&"
import script from "./debtorIpu.vue?vue&type=script&lang=js&"
export * from "./debtorIpu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports